export default "__VITE_ASSET__NufYgKpM__"